import picturefill from 'picturefill'
const fancybox = require('@fancyapps/fancybox');
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
export default function commonJs() {

  // fancybox設定
  //------------------------------------------------------
  $(document).ready(function() {
    $('.article').each(function(i) {
      $(this).find('a > img').parent().attr('data-fancybox', 'group-' + i);
    });
  });

}